'use strict';

var ChartPricingDepartureDatesDirective = function ChartPricingDepartureDatesDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    template: require('../templates/chart-pricing-departure-dates.html'),
    scope: {
      isCollapsible: '=',
      isChartVisible: '=?',
      listenedBrushNames: '=?'
    },
    replace: true,
    controller: 'ChartPricingDepartureDatesController',
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      scope.renderChartDataPresent = function (data, selectionSize) {
        scope.$evalAsync(function () {
          data = data || scope.data;
          if (scope.isChartVisible) {
            var currentRange = scope.currentRange;
            scope.data = data || [];
            chart.render(data);
            viewport.render(data, selectionSize, chart.getMaxRangeSize());
            viewport.setInitialSelection(currentRange);
          } else if (data) {
            chart.data = data;
          }
        });
      };
      scope.setInitialSelection = function (range) {
        chart.setInitialSelection(range);
      };
      scope.toggleChartVisibility = function () {
        scope.isChartVisible = !scope.isChartVisible;
        if (scope.isChartVisible) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      };
      scope.$watch('isChartVisible', function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      });

      // brush change in the viewport chart affects what's visible in the main chart
      viewport.on('rangechange', function (range) {
        scope.currentRange = range;
        if (scope.isChartVisible) {
          chart.domainChange(range);
          chart.domainChange(range);
        }
      });

      //reset chart with the new data
      scope.$on('search-criteria:searchChangeEvent', function () {
        scope.invalidateData();
        scope.initChart();
      });
      scope.$on('chart:DepartureDate:filterUpdate', function () {
        scope.resetRange();
        scope.initChart();
      });
      scope.$on('$destroy', function () {
        viewport.on('rangechange', null);
      });
      scope.$on('chart:DepartureDate:reset', function () {
        scope.resetRange();
        scope.selectAllDepartureDate();
      });
      chart.on('selectedDepartureDate', function (departureDate, index) {
        scope.selectDepartureDate(departureDate, index);
      });
    }
  };
};
ChartPricingDepartureDatesDirective.$inject = ['PricingDepartureDatesChart', 'PricingDepartureDatesChartViewport'];
module.exports = ChartPricingDepartureDatesDirective;